module.exports = __webpack_public_path__ + "static/img/signup_illustration.c789690.svg";